let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("tr1BO")).then(() => parcelRequire('37saP'));